module.exports = __webpack_public_path__ + "static/img/error.b3bd0483.png";